import { useEffect, useState } from 'react';
import cx from 'classnames';
import styles from 'partials/checkbox.module.scss';

export const CheckboxItem = (props) => {
	const [check, setCheck] = useState(props.isChecked);

	const handleCheckbox = (e) => {
		e.preventDefault();
		setCheck(!check);
		props.onChange?.(props.item, !check);
	};

	useEffect(() => {
		setCheck(props.isChecked);
	}, [props.isChecked]);

	const checkboxClass = cx(styles.box, props.className, {
		[styles.checked]: check
	});
	const Icon = props.icon;

	return (
		<div
			role="button"
			tabIndex="0"
			className={checkboxClass}
			onClick={(e) => (!props.disabled ? handleCheckbox(e) : null)}
			onKeyPress={(e) => (!props.disabled ? handleCheckbox(e) : null)}>
			<input
				type="checkbox"
				ref={props.ref}
				className={styles.input}
				id={props.id}
				value={props.id}
				checked={check}
				onChange={handleCheckbox}
			/>
			<div className={styles.body}>
				{props.icon && (
					<Icon
						className={cx(styles.icon, props.iconClass)}
						size={24}
					/>
				)}
				<span className={styles.label}>{props.label}</span>
			</div>

			<div className={styles.track}>
				<span className={styles.indicator}></span>
			</div>
		</div>
	);
};
